module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetMedium@2x.90bd27f.jpg";